"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkSelectCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Table_1 = require("../Table/Table");
const BulkSelectCell = ({ userRole, isSelected, onToggle, canDelete = true, disabledReason, allowedRoles = ['SUPER_ADMIN', 'ADMIN'], }) => {
    if (!userRole || !allowedRoles.includes(userRole)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(Table_1.TableCell, { className: "relative", style: { width: '60px', paddingLeft: '24px', paddingRight: '12px' }, children: (0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isSelected, onChange: onToggle, className: "h-4 w-4 rounded border-gray-300 text-brand-600 focus-visible:ring-brand-500", disabled: !canDelete, title: !canDelete && disabledReason ? disabledReason : '', style: { position: 'absolute', left: '40px' } }) }) }));
};
exports.BulkSelectCell = BulkSelectCell;
exports.BulkSelectCell.displayName = 'BulkSelectCell';
